module.exports = __webpack_public_path__ + "static/gps_image1-7e67ec1a89444b62e939096b4b86d1f8.png";